export const constant = {
  Api_Key: "145f4376b0638f0c9d3f53be5eb483ae",
  IMG_POSTER_URL: "https://image.tmdb.org/t/p/w500",
  IMG_FULLSIZE_URL: "https://image.tmdb.org/t/p/original",
};
